/*
 * Karusell-piler: sentrer pilene og «Vis alle» vertikalt på produktbildet.
 *
 * Pilene (.slider-buttons) ligger inne i <slider-component>, mens «Vis alle»
 * (.collection__view-all) er en søsken etter slideren og posisjoneres mot
 * .collection. Prosent-verdier i CSS treffer derfor ulike høyder, og ingen av
 * dem følger bildet. Her måles posisjonene, og resultatet settes som
 * CSS-variabler som custom_products_cards_etc.css bruker:
 *   --pc-arrow-y   (på slider-component) – midten av produktbildet
 *   --pc-viewall-y (på .collection)       – midten av høyrepilen
 *
 * Avstanden fra .collection ned til slideren kan endre seg etter første
 * måling (asynkron CSS, fonter), uten at slideren endrer størrelse. Derfor
 * måles det også når .collection endrer størrelse, og når slideren scrolles.
 */
(function () {
  function position(slider) {
    var collection = slider.closest('.collection');
    var media = slider.querySelector('.slider__slide .card__inner');
    if (!collection || !media) return;

    var mediaRect = media.getBoundingClientRect();
    if (!mediaRect.height) return;

    var sliderTop = slider.getBoundingClientRect().top + slider.clientTop;
    slider.style.setProperty('--pc-arrow-y', (mediaRect.top + mediaRect.height / 2 - sliderTop) + 'px');

    // Mål høyrepilen etter at --pc-arrow-y er satt, så «Vis alle» havner
    // nøyaktig der pilen står. Faller tilbake til bildemidten hvis pilen er skjult.
    var next = slider.querySelector('.slider-button--next');
    var nextRect = next ? next.getBoundingClientRect() : null;
    var centerY = nextRect && nextRect.height
      ? nextRect.top + nextRect.height / 2
      : mediaRect.top + mediaRect.height / 2;

    var collectionTop = collection.getBoundingClientRect().top + collection.clientTop;
    collection.style.setProperty('--pc-viewall-y', (centerY - collectionTop) + 'px');
  }

  function init() {
    document.querySelectorAll('.collection slider-component').forEach(function (slider) {
      position(slider);
      if (slider.dataset.pcArrowObserved) return;
      slider.dataset.pcArrowObserved = 'true';

      var update = function () { position(slider); };
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(update);
        observer.observe(slider);
        observer.observe(slider.closest('.collection'));
      }

      var track = slider.querySelector('[id^="Slider-"]');
      if (track) {
        var queued = false;
        track.addEventListener('scroll', function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () { queued = false; update(); });
        }, { passive: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);

  // Temaeditoren laster seksjoner på nytt uten full sideinnlasting
  document.addEventListener('shopify:section:load', init);
})();
